export default {
  locale: 'zh-cn',
  TableFilter: {
    resultLabel: '筛选',
    expanse: '展开筛选',
    clear: '清空筛选项',
    emptyField: '无查询项',
    total: '共',
    totalInfo: '条记录',
  },
  Tag: {
    verifiedInvoice: '发票已验',
    freeInvoice: '免票',
    childFee: '子'
  },
  HelpComponent: {
    more: 'More',
  },
  FeeTypeInput : {
    none: '未填写',
    placeholder:'请选择费用类型',
  },
};
